import { Logout } from "@mui/icons-material";

export const userAccountMenu = [
    {
        name: 'Log Out',
        href: '/login',
        icon: Logout
    }
]
